import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "floristos_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

let onUnauthorized = null;
export const setUnauthorizedHandler = (fn) => {
  onUnauthorized = fn;
};

const client = axios.create({ baseURL: BASE });

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const FIELD_ID = { pin: "PIN", password: "Password", email: "Email", name: "Nama", username: "Username", employee_id: "ID Karyawan", phone: "No. HP", role_name: "Peran" };

function formatDetail(detail, status) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msgs = detail.map((e) => {
      const loc = Array.isArray(e?.loc) ? String(e.loc[e.loc.length - 1] || "") : "";
      const name = FIELD_ID[loc] || loc;
      if (e?.type === "string_too_short") return `${name} minimal ${e?.ctx?.min_length} karakter`;
      if (e?.type === "string_too_long") return `${name} maksimal ${e?.ctx?.max_length} karakter`;
      if (e?.type?.includes?.("email")) return "Format email tidak valid";
      return e?.msg ? (name ? `${name}: ${e.msg}` : e.msg) : "";
    });
    const joined = msgs.filter(Boolean).join("\n");
    if (joined) return joined;
  }
  return detail?.message || `Request failed (${status})`;
}

client.interceptors.response.use(
  (res) => res,
  (error) => {
    const url = error.config?.url || "";
    // Only force logout on session-expiry (auth endpoints / token check), not on
    // business 401s like a wrong Owner PIN during reset actions.
    const isSessionCheck = url.startsWith("/auth/") && !url.includes("/login");
    if (error.response?.status === 401 && isSessionCheck && onUnauthorized) onUnauthorized();
    const detail = error.response?.data?.detail;
    const msg = error.response ? formatDetail(detail, error.response.status) : error.message || "Terjadi kesalahan";
    const wrapped = new Error(msg);
    wrapped.status = error.response?.status;
    wrapped.data = error.response?.data;
    return Promise.reject(wrapped);
  }
);

export const api = {
  get: async (path, params) => (await client.get(path, { params })).data,
  post: async (path, body) => (await client.post(path, body)).data,
  patch: async (path, body) => (await client.patch(path, body)).data,
  del: async (path, params) => (await client.delete(path, { params })).data,
};

export const fileUrl = (fileId) =>
  fileId ? `${BASE}/files/${fileId}?token=${encodeURIComponent(getToken() || "")}` : "";

export const exportUrl = (kind, params = {}) => {
  const qs = new URLSearchParams({ ...params, token: getToken() || "" }).toString();
  return `${BASE}/reports/export/${kind}?${qs}`;
};

export async function uploadImage(file) {
  const form = new FormData();
  form.append("file", file);
  const res = await client.post("/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}
